import { Loading } from '@alpine-iq/ui-library';
import React from 'react';

export default function LoadingScreen({ fullPage }: { fullPage?: boolean }) {
	return (
		<>
			<div
				css={`
					display: flex;
					justify-content: center;
					align-items: center;
					height: ${fullPage ? '100vh' : '100%'};
					width: 100%;
				`}
			>
				<Loading />
			</div>
		</>
	);
}
